export default {
    props: {
        slide: {
            type: Object,
            require: true,
        },
    },
}